// extracted by mini-css-extract-plugin
export default {"containerDefault":"Rates_containerDefault__pUJ4k"};